if (!customElements.get('blend-cards-slider') && typeof SliderComponent !== 'undefined') {
  customElements.define(
    'blend-cards-slider',
    class BlendCardsSlider extends SliderComponent {
      constructor() {
        super();
        this.enableSliderLooping = true;
        if (this.prevButton) this.prevButton.removeAttribute('disabled');
        if (this.nextButton) this.nextButton.removeAttribute('disabled');
      }

      onButtonClick(event) {
        event.preventDefault();
        const isNext = event.currentTarget.name === 'next';
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        const atEnd = this.slider.scrollLeft >= maxScroll - 2;
        const atStart = this.slider.scrollLeft <= 2;

        if (isNext && atEnd) {
          this.setSlidePosition(0);
        } else if (!isNext && atStart) {
          this.setSlidePosition(maxScroll);
        } else {
          super.onButtonClick(event);
        }
      }
    }
  );
}
